"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tinymce = require("tinymce/tinymce");
require("tinymce-i18n/langs/fr_FR");
require("tinymce/skins/lightgray/skin.min.css");
require("tinymce/themes/modern/theme");
require("tinymce/plugins/table");
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/noneditable");
require("tinymce/plugins/paste");
require("tinymce/plugins/textcolor");
$.fn.wysiwygEditor = function (options) {
    var $el = $(this);
    options = $.extend({
        target: $el.get(0),
        skin: false,
        plugins: ["table", "lists", "link", "noneditable", "paste", "textcolor"],
        toolbar: "undo redo | styleselect | removeformat | bold italic underline strikethrough | fontselect fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
        branding: false
    }, options);
    tinymce.init(options).then(function (editors) {
        $el.data("wysiwyg-editor", editors[0]);
        $el.addClass("wysiwyg");
    });
    return this;
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/UI/wysiwyg.ts
// module id = 482
// module chunks = 0